export interface InventoryStockBalanceRow {
  id: string;
  item_id: string;
  item_code: string;
  item_name: string;
  store_id: string;
  store_code: string;
  store_name: string;
  company_id: string;
  company_name: string;
  lot_no: string;
  bin_location: string;
  on_hand_qty: number;
  allocated_qty: number;
  available_qty: number;
  last_price: number;
  updated_at: string;
  last_received_at?: string;
  last_movement_at?: string;
  note: string;
}

export interface InventoryStockBalanceFormData {
  item_code: string;
  item_name: string;
  store_code: string;
  store_name: string;
  lot_no: string;
  bin_location: string;
  on_hand_qty: string;
  allocated_qty: string;
  available_qty: string;
  last_price: string;
  updated_at: string;
  last_received_at?: string;
  last_movement_at?: string;
  company_id: string;
  company_name?: string;
  note: string;
}

export const stockBalanceStateOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'available', name: 'Còn khả dụng' },
  { id: 'allocated', name: 'Có giữ chỗ' },
  { id: 'shortage', name: 'Thiếu khả dụng' },
];

const todayString = new Date().toISOString().slice(0, 10);

export const createDefaultStockBalanceForm = (companyId: string): InventoryStockBalanceFormData => ({
  item_code: '',
  item_name: '',
  store_code: '',
  store_name: '',
  lot_no: '',
  bin_location: '',
  on_hand_qty: '0',
  allocated_qty: '0',
  available_qty: '0',
  last_price: '0',
  updated_at: todayString,
  company_id: companyId,
  note: '',
});

export const buildStockBalanceRowFromForm = (
  formData: InventoryStockBalanceFormData,
  id: string,
  companyName: string,
): InventoryStockBalanceRow => {
  const onHandQty = Number(formData.on_hand_qty) || 0;
  const allocatedQty = Number(formData.allocated_qty) || 0;
  const availableQty = onHandQty - allocatedQty;
  const lastPrice = Number(formData.last_price) || 0;

  return {
    id,
    item_id: id,
    item_code: formData.item_code.trim(),
    item_name: formData.item_name.trim(),
    store_id: `${formData.company_id}-${formData.store_code.trim() || 'store'}`,
    store_code: formData.store_code.trim(),
    store_name: formData.store_name.trim(),
    company_id: formData.company_id,
    company_name: companyName,
    lot_no: formData.lot_no.trim(),
    bin_location: formData.bin_location.trim(),
    on_hand_qty: onHandQty,
    allocated_qty: allocatedQty,
    available_qty: availableQty,
    last_price: lastPrice,
    updated_at: formData.updated_at,
    note: formData.note.trim(),
  };
};